import React, { useState, useEffect } from "react";
import JudgeLayout from "../../layout/judgeLayout";
import {
  Steps,
  Empty,
  Typography,
  message,
  Button,
  Slider,
  Form,
  InputNumber,
  Row,
  Col,
  Result,
} from "antd";
import { useSearchParams } from "react-router-dom";
import Axios from "axios";

import { apiRoutes, environment } from "../../auth/apiRoute";

import LoadingFrame from "../../layout/loadingFrame";
import "./dashboard.css";
const { Step } = Steps;
const { Paragraph, Title, Text } = Typography;
export default function JudgeDashboard(props) {
  const [form] = Form.useForm();
  const [currentStep, setCurrentStep] = useState(0);
  const [currentNomination, setCurrentNomination] = useState({});
  const [nominationsData, setNominationsData] = useState([]);
  const [delayed, setDelayed] = useState(true);
  const questions = [
    "1. Describe the employee’s overall job performance and dedication to his/her profession and to your Hotel. Please be specific and cite at least one example.",
    "2. Describe the interaction of the employee with his/her coworkers and/or with guests. Please cite specific examples of the employee’s positive impact on the guest experience at your hotel. ",
    "3. Please list any awards or recognition that the employee has received from the Hotel, management, guests, award organizations and/or peers.",
    "4. Please list any other reasons for nominating this employee for the Big Apple Stars Awards.",
  ];
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    getMyNominations();
  }, []);

  useEffect(() => {
    if (currentNomination) {
      var defaultNomination = Object.assign(currentNomination, {});
      for (const question of ["q1", "q2", "q3", "q4"]) {
        if (defaultNomination[question]) {
          if (!defaultNomination[question].hasOwnProperty("score")) {
            defaultNomination[question].score = "";
          }
        } else {
          defaultNomination[question] = { score: "" };
        }
      }

      form.setFieldsValue(defaultNomination);
    }
  }, [currentNomination]);
  const [loading, setLoading] = useState(false);

  const getMyNominations = async () => {
    setLoading(true);
    var userEmail;
    if (searchParams.get("userEmail") || searchParams.get("useremail")) {
      userEmail =
        searchParams.get("userEmail") || searchParams.get("useremail");
    }
    try {
      const response = await Axios.post(
        apiRoutes[environment].mynominationstojudge,
        { userEmail: userEmail },
      );

      if (response.status == 200) {
        var nominations = response.data;

        nominations = nominations.map((item) => {
          return { ...item, ...{ key: item._id } };
        });
        console.log(nominations);
        setNominationsData(nominations);
        setCurrentNomination(nominations[currentStep]);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const questionsAndAnswers = (step) => {
    var formItems = questions.map((question, index) => {
      return (
        <Row key={index + "q"}>
          <Col span={13}>
            <Paragraph>
              <Text>{question}</Text>
              <Paragraph className="admin-view-nomination-answer">
                {currentNomination["q" + (index + 1)] &&
                currentNomination["q" + (index + 1)].answer ? (
                  <p className="display-linebreak">
                    {" "}
                    {currentNomination["q" + (index + 1)].answer}
                  </p>
                ) : (
                  <Empty description={"No response"} />
                )}
              </Paragraph>
            </Paragraph>
          </Col>
          <Col md={4} sm={12}>
            <div
              style={{
                bottom: 0,
                display: "flex",
                height: "100%",
                flexDirection: "column",
                paddingBottom: "1em",
              }}
            >
              <div className="spacer"></div>

              <div style={{ display: "flex", alignItems: "baseline" }}>
                <Text style={{ paddingLeft: "2px" }}>Your score:</Text>
                <Form.Item name={["q" + (index + 1), "score"]}>
                  <InputNumber
                    disabled={
                      !currentNomination["q" + (index + 1)] ||
                      !currentNomination["q" + (index + 1)].answer
                    }
                    min={0}
                    max={10}
                    step={0.5}
                    style={{ margin: "0 16px" }}
                    onChange={(value) => {
                      var newNominationData = currentNomination;

                      newNominationData["q" + (index + 1)].score = value;
                      setCurrentNomination(newNominationData);
                    }}
                  />
                </Form.Item>
              </div>
            </div>
          </Col>
        </Row>
      );
    });

    return (
      <Form
        onFinish={onFinish}
        form={form}
        initialValues={currentNomination}
        key={step}
      >
        NO. {step + 1}
        <Title level={5} style={{ paddingLeft: "1px" }}>
          Score Range, Min: 0 , Max : 10
        </Title>
        {formItems} {footer()}
      </Form>
    );
  };

  const sider = () => {
    const checkIfFinished = (nomination) => {
      var bool = true;
      for (var i = 1; i < 5; i++) {
        if (
          nomination["q" + i] &&
          nomination["q" + i].answer &&
          (!nomination["q" + i].hasOwnProperty("score") ||
            !nomination["q" + i].score)
        ) {
          bool = false;
        }
      }

      return bool;
    };
    var stepsOption = nominationsData.sort().map((nomination, index) => {
      var titleValue = "In Progress";
      if (currentStep < index) {
        titleValue = "Waiting";
      }

      if (checkIfFinished(nomination)) {
        titleValue = "Finished";
      }

      return (
        <Step
          key={index + nomination._id}
          title={titleValue}
          description={nomination.category}
        />
      );
    });
    if (nominationsData.length == 0) {
      return;
    }
    return (
      <div style={{ color: "white" }}>
        <Steps
          progressDot
          direction="vertical"
          current={currentStep}
          onChange={(current) => {
            setCurrentStep(current);
            setCurrentNomination(nominationsData[current]);
          }}
        >
          {stepsOption}
        </Steps>
      </div>
    );
  };
  const footer = () => {
    if (nominationsData) {
      var nominations = nominationsData;
      var total = nominationsData.length;
      const index = nominations.findIndex(
        (item) => item == currentNomination._id,
      );
      return (
        <Col span={16}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              disabled={currentStep == 0}
              onClick={() => {
                if (currentStep == nominationsData.length) {
                  setCurrentStep(0);
                  setCurrentNomination(nominationsData[0]);
                } else {
                  setCurrentStep(currentStep - 1);
                  setCurrentNomination(nominationsData[currentStep - 1]);
                }
              }}
            >
              {currentStep == total ? "Check Again" : "Previous"}
            </Button>

            <Form.Item>
              <Button
                htmlType="submit"
                disabled={currentStep == total}
                // onClick={() => {
                //   setCurrentStep(currentStep + 1);
                //   if (nominationsData[currentStep + 1]) {
                //     setCurrentNomination(nominationsData[currentStep + 1]);
                //   }
                // }}
              >
                {currentStep == total - 1
                  ? "Confirm & Finish"
                  : "Confirm & Next"}
              </Button>
            </Form.Item>
          </div>
        </Col>
      );
    }
  };

  const onFinish = (values) => {
    updateScore(currentNomination);
    setCurrentStep(currentStep + 1);
    form.resetFields();
    if (nominationsData[currentStep + 1]) {
      setCurrentNomination(nominationsData[currentStep + 1]);
      // form.setFieldsValue(nominationsData[currentStep + 1]);
    }
  };

  const updateScore = async (newNomination) => {
    setLoading(true);
    try {
      const response = await Axios.post(
        apiRoutes[environment].updateScore,
        newNomination,
      );

      if (response.status == 200) {
        message.success({
          content: "Scores have been updated. ",
          className: "messageBox",
        });
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };

  if (!props.isJudgingNomination) {
    return (
      <Result
        status="success"
        title="Thank you!"
        subTitle="The first round judge is completed. Thank you for your support!"
      />
    );
  }
  return (
    <JudgeLayout sidebar={sider()}>
      <LoadingFrame loading={loading}>
        {currentStep < nominationsData.length ? (
          <>
            <Text>
              Category:{" "}
              <Title level={2}>
                {currentNomination && currentNomination.category
                  ? currentNomination.category
                  : ""}
              </Title>
            </Text>
            {questionsAndAnswers(currentStep)}
          </>
        ) : (
          <Result
            status="success"
            title="Thanks for your time!"
            extra={[
              <Button
                type="primary"
                key="console"
                onClick={() => {
                  setCurrentStep(0);
                  setCurrentNomination(nominationsData[0]);
                }}
              >
                Go back and review
              </Button>,
            ]}
          />
        )}
      </LoadingFrame>
    </JudgeLayout>
  );
}
